import {setupAppConfig} from '@/src/utils/appConfig';
import {initializeGrafana} from '@/src/utils/initializeGrafana';
import {logError} from '@/src/utils/logger';

async function loadRemoteConfig() {
	try {
		const {protocol, host} = window.location;
		const url = `${protocol}//${host}${window.__APP_PREFIX}config.json`;
		const response = await fetch(url, {method: 'GET'});
		const data = await response.json();
		return setupAppConfig(data);
	} catch (cause) {
		throw new Error('Unable to load and parse config.json', {cause});
	}
}

/**
 * Read more what and why this is created for:
 *
 * https://web.dev/bfcache/#ways-to-opt-out-of-bfcache
 * https://stackoverflow.com/a/13123626/2512628
 * https://developer.mozilla.org/en-US/docs/Mozilla/Firefox/Releases/1.5/Using_Firefox_1.5_caching
 * https://dockyard.com/blog/2021/01/21/how-single-page-apps-and-bfcache-impact-the-user-experience
 * https://developer.mozilla.org/en-US/docs/Web/API/Location/assign
 * https://developer.mozilla.org/en-US/docs/Web/API/Location/replace
 */
function bfcacheFix() {
	window.addEventListener('pageshow', (event) => {
		if (event.persisted) {
			window.location.reload();
		}
	});
}

async function bootstrap() {
	try {
		bfcacheFix();
		const {GRAFANA_FARO_APP_URL, PROPAGATE_TRACE_HEADER_URL} = await loadRemoteConfig();
		if (GRAFANA_FARO_APP_URL && PROPAGATE_TRACE_HEADER_URL) {
			initializeGrafana(GRAFANA_FARO_APP_URL, PROPAGATE_TRACE_HEADER_URL);
		}
		const {main} = await import(/* webpackChunkName: "bootstrap" */ './bootstrap');
		await main();
	} catch (err) {
		logError('Root level crash!')(err);
		const body = document.getElementsByTagName('body').item(0) as HTMLBodyElement;
		body.innerHTML = `<main style="text-align: center;">
			<h1>An error occurred while loading the application.</h1>
			<p>Please try again. If this error persists, please contact support at
			<a href="mailto:support@bluedrop.com">support@bluedrop.com</a>.</p>
		</main>`;
	}
}

bootstrap();
